import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavMenuService } from 'src/app/services/shared/nav-menu.service';
import * as atlas from 'azure-maps-control';
import { Chart, scales } from 'chart.js';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import * as _ from 'lodash'
import zoomPlugin from 'chartjs-plugin-zoom';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { LoginService } from 'src/app/services/security/login.service';
import { formatDate } from '@angular/common';

@Component({
  selector: 'neoris-devices-availability',
  templateUrl: './devices-availability.component.html',
  styleUrl: './devices-availability.component.css'
})
export class DevicesAvailabilityComponent implements OnInit, OnDestroy {

  user: string
  user_principal_name: string
  public device: { Name?, Type?, Location?, Site?, LastConnection?, LastEvent?, ConnectionStatus?, summary?} = {
    Name: "",
    Type: "", 
    Location: "", 
    Site: "", 
    LastConnection: "", 
    LastEvent: "", 
    ConnectionStatus: "", 
    summary: ""
   }

  today = new Date();
  month = this.today.getUTCMonth();
  year = this.today.getUTCFullYear();
  day = this.today.getUTCDate()

  private startDate: Date = new Date(this.year, this.month, this.day)
  private endDate: Date = new Date(this.year, this.month, this.day, this.today.getHours(), this.today.getMinutes())
  private mapLoaded: boolean = false

  public chartFilters = new UntypedFormGroup({
    chartType: new UntypedFormControl(''),
    queryType: new UntypedFormControl('DAY'),
    start: new UntypedFormControl(new Date(this.startDate.setDate(this.startDate.getDate() - 30))),
    end: new UntypedFormControl(new Date(this.endDate.setDate(this.endDate.getDate()))),
  });

  public availabilityDeviceModel: { uptime } = { uptime: 0 }
  public chartOptions: { Value, Description, Type, Device }[] = []
  public allChartOptions: { Value, Description, Type, Device }[] = [
    { Value: 'FREE_DISK_SPACE_PERCENTAGE', Description: 'Free Disk Space', Type: 'Characteristic', Device: 'Industrial computer' },
    { Value: 'RAM_USAGE_PERCENTAGE', Description: 'Ram Usage', Type: 'Characteristic', Device: 'Industrial computer' },
    { Value: 'VIDEO_RAM_USAGE_PERCENTAGE', Description: 'Video Ram Usage', Type: 'Characteristic', Device: 'Industrial computer' },
    { Value: 'CPU_AVG_USAGE_PERCENTAGE', Description: 'Cpu Avg Usage', Type: 'Characteristic', Device: 'Industrial computer' },
    { Value: 'CONNECTION_LOST', Description: 'Connection lost', Type: 'Connectivity', Device: 'All' }
  ]

  public queryType: { Value, Description }[] = [
    { Value: "MONTH", Description: 'Month' },
    { Value: "DAY", Description: 'Day' },
    { Value: "HOUR", Description: 'Hour' },
  ]

  @ViewChild('mapElement') streetsideMapViewChild: ElementRef;
  destroyed = new Subject<void>();
  currentScreenSize: string;
  displayNameMap = new Map([
    [Breakpoints.XSmall, 'XSmall'],
    [Breakpoints.Small, 'Small'],
    [Breakpoints.Medium, 'Medium'],
    [Breakpoints.Large, 'Large'],
    [Breakpoints.XLarge, 'XLarge'],
  ]);

  public showfilterChart: boolean = true
  private lang: string = "en";
  
  private onLanChange: Subscription

  minDate: Date;
  maxDate: Date;
   

  constructor(
    private service: ControltowerService,
    private navMenuService: NavMenuService,
    private translate: TranslateService,
    public breakpointObserver: BreakpointObserver,
    private securityService: LoginService) {
      
      let _endDate: Date = new Date(this.year, this.month, this.day)


      this.minDate = new Date(2024, 1, 1);
      this.maxDate = new Date(_endDate.setDate(_endDate.getDate()))
      
    this.onLanChange = this.translate.onLangChange.subscribe(s => {
      this.lang = s.lang
      this.RenderConnectivityChart()

    })

    Chart.register(zoomPlugin);
    this.breakpointObserver
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
        Breakpoints.XLarge,
      ])
      .pipe(takeUntil(this.destroyed))
      .subscribe(result => {
        for (const query of Object.keys(result.breakpoints)) {
          if (result.breakpoints[query]) {
            this.currentScreenSize = this.displayNameMap.get(query) ?? 'Unknown';
            switch (this.currentScreenSize) {
              case "XSmall":
                this.showfilterChart = false
                break;
              case "Small":
                this.showfilterChart = false
                break;
              case "Medium":
                this.openCardControlsMini = false
                break;
              case "Large":
                this.openCardControlsMini = false
                break;
              case "XLarge":
                this.openCardControlsMini = false
                  break;
              default:
                this.showfilterChart = true
                break;
            }
          }
        }
      });
  }

  private sitesId: string = "";
  private deviceId: string = "";

  async ngOnInit():  Promise<void> {
    const userName = JSON.parse(localStorage.getItem('ud'))[1].value
    const guid = JSON.parse(localStorage.getItem('guidSession'))
    const response = await this.securityService.login(userName,guid).toPromise()


    this.ShowSelectedDevice();
    this.ShowDeviceChartOptions()
    this.getDevicesAvailability();
  }

  ngOnDestroy(): void {
    this.onLanChange.unsubscribe()
  }

  private ShowDeviceChartOptions(){

    this.chartOptions = this.allChartOptions.filter(f => f.Device == this.device.Type)

    this.allChartOptions.filter(f => f.Device == 'All').forEach(f => {
      this.chartOptions.push(f);
    })

    this.chartFilters.get('chartType').setValue(this.chartOptions[0].Value)

  }

  private ShowSelectedDevice() {
    const selectedDevice: any = JSON.parse(localStorage.getItem('rowSelectDevice'))

    this.deviceId = selectedDevice.sourceDeviceId;
    this.sitesId = selectedDevice.siteId;

    this.device.LastConnection = selectedDevice.LastConnection
    this.device.LastEvent = selectedDevice.LastEvent
    this.device.Location = selectedDevice.Location
    this.device.Name = selectedDevice.Name
    this.device.Site = selectedDevice.Site
    this.device.Type = selectedDevice.Type
    this.device.summary = selectedDevice.summary
    this.device.ConnectionStatus = selectedDevice.ConnectionStatus

  }

  private deviceAvailabilityData: any = []

  private async getDevicesAvailability(): Promise<boolean> {

    const now = new Date();
    const startDate: Date = this.chartFilters.get('start').value
    const endDate: Date = this.chartFilters.get('end').value

    const _startDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 1)
    const _endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59)

    let paramDto = {
      sites: [this.sitesId],
      devices: [this.deviceId],
      startDate: formatDate(_startDate, 'yyyy-MM-dd HH:mm:ss', 'en-US'),
      endDate: formatDate(_endDate, 'yyyy-MM-dd HH:mm:ss', 'en-US'),
    }

    return new Promise<boolean>((resolve, reject) => {

      this.service.getDevicesAvailabilityInfo(paramDto).subscribe(
        {
          next: (data: any) => {

            this.deviceAvailabilityData = data;

            this.minDate = this.deviceAvailabilityData.firstHistoryDate

            this.ShowDevicesAvailabilityData();

            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  private ShowDevicesAvailabilityData() {
    
    if(this.deviceAvailabilityData.devicesUptime.length > 0){
      this.availabilityDeviceModel.uptime  = this.deviceAvailabilityData.devicesUptime[0].uptime
    }

    this.RenderMap(this.deviceAvailabilityData)
    this.RenderConnectivityChart()
  }

  private RenderMap(data: any) {
    if (this.mapLoaded == false) {

      this.mapLoaded = true
      let firstPoint: { long, lat } = { long: 0, lat: 0 };
      if (data.deviceLocations.length > 0) {
        firstPoint.long = data.deviceLocations[0].long
        firstPoint.lat = data.deviceLocations[0].lat
      }


      let map = new atlas.Map('myMap', {
        center: [firstPoint.long, firstPoint.lat],
        zoom: 4,

        language: 'es-MX',
        showLogo: false,
        authOptions: {
          authType: atlas.AuthenticationType.subscriptionKey,
          subscriptionKey: 'Vr_B7hBq7ekOnVZcl1mJgCBxklPUWWsA-4dt4jzQ3-0'
        }
      });

      map.controls.add([
        new atlas.control.ZoomControl,
        new atlas.control.CompassControl,
        new atlas.control.StyleControl,
      ],
        {
          position: atlas.ControlPosition.BottomRight
        })

      let addLayerToMap = (map: any, deviceLocations: any, image: string) => {
        if (deviceLocations.length > 0) {
          /*Create a data source and add it to the map*/
          let dataSource = new atlas.source.DataSource();
          map.sources.add(dataSource);

          deviceLocations.forEach(location => {
            let point = new atlas.Shape(new atlas.data.Point([location.long, location.lat]));

            dataSource.add([point]);
          });

          let symbolLayer = new atlas.layer.SymbolLayer(dataSource);
          map.layers.add(symbolLayer);

          let defaultOptions = symbolLayer.getOptions();
          defaultOptions.iconOptions.image = image
          symbolLayer.setOptions(defaultOptions);
        }
      }

      map.events.add('ready', function () {
        let offline_locations = data.deviceLocations.filter(f => f.connectionStatus == 'offline')
        addLayerToMap(map, offline_locations, 'marker-red')

        let no_offline_locations = data.deviceLocations.filter(f => f.connectionStatus !== 'offline')
        addLayerToMap(map, no_offline_locations, 'marker-blue')
      });
    }
  }

  private DestroyChart(chartName: string) {
    let chartExist = Chart.getChart(chartName);
    if (chartExist != undefined)
      chartExist.destroy();
  }

  private GroupInfoByHourDay(data: any, queryType: string, chart_type: string, locale: string) {
    data.devicesStatusHistory.map(m => {
      let _date: Date = undefined;
      _date = m.scanDt
      let date = new Date(_date).getDate()
      let str_date = ''
      if (date < 10) {
        str_date = '0' + date
      } else {
        str_date = '' + date
      }

      switch (queryType) {
        case 'MONTH':
          m.chartDate = new Date(_date).getFullYear() + '-' + this.months.find(f => f.monthNumber == (new Date(_date).getMonth() + 1) && f.locale == locale).monthName
          break;
        case 'DAY':
          m.chartDate = new Date(_date).getFullYear() + '-' + this.months.find(f => f.monthNumber == (new Date(_date).getMonth() + 1) && f.locale == locale).monthName + '-' + str_date
          break;
        case 'HOUR':
          let hours = new Date(_date).getHours()
          let minutes = new Date(_date).getMinutes()
          let str_hours = ''
          let str_minutes = ''

          if (date < 10) {
            str_date = '0' + date
          } else {
            str_date = '' + date
          }

          if (hours < 10) {
            str_hours = '0' + hours
          } else {
            str_hours = '' + hours
          }

          if (minutes < 10) {
            str_minutes = '0' + minutes
          } else {
            str_minutes = '' + minutes
          }

          m.chartDate = new Date(_date).getFullYear() + '-' + this.months.find(f => f.monthNumber == (new Date(_date).getMonth() + 1) && f.locale == locale).monthName + '-' + str_date + ' ' + str_hours + ':' + str_minutes
          break;
      }
      return m
    })
  }

  private months: { monthNumber: number, monthName: string, locale: string }[] = [
    { monthNumber: 1, monthName: 'Ene', locale: 'es' },
    { monthNumber: 2, monthName: 'Feb', locale: 'es'  },
    { monthNumber: 3, monthName: 'Mar', locale: 'es'  },
    { monthNumber: 4, monthName: 'Abr', locale: 'es'  },
    { monthNumber: 5, monthName: 'May', locale: 'es'  },
    { monthNumber: 6, monthName: 'Jun', locale: 'es'  },
    { monthNumber: 7, monthName: 'Jul', locale: 'es'  },
    { monthNumber: 8, monthName: 'Ago', locale: 'es'  },
    { monthNumber: 9, monthName: 'Sept', locale: 'es'  },
    { monthNumber: 10, monthName: 'Oct', locale: 'es'  },
    { monthNumber: 11, monthName: 'Nov', locale: 'es'  },
    { monthNumber: 12, monthName: 'Dic', locale: 'es'  },
    { monthNumber: 1, monthName: 'Jan', locale: 'en'  },
    { monthNumber: 2, monthName: 'Feb', locale: 'en' },
    { monthNumber: 3, monthName: 'Mar', locale: 'en' },
    { monthNumber: 4, monthName: 'Apr', locale: 'en' },
    { monthNumber: 5, monthName: 'May', locale: 'en' },
    { monthNumber: 6, monthName: 'Jun', locale: 'en' },
    { monthNumber: 7, monthName: 'Jul', locale: 'en' },
    { monthNumber: 8, monthName: 'Aug', locale: 'en' },
    { monthNumber: 9, monthName: 'Sep', locale: 'en' },
    { monthNumber: 10, monthName: 'Oct', locale: 'en' },
    { monthNumber: 11, monthName: 'Nov', locale: 'en' },
    { monthNumber: 12, monthName: 'Dec', locale: 'en' }
  ]

  validateNull(value:any):number{

    let dataFinish = value == null ? 0 : value

    return dataFinish

  }

  fillGroupByDateValues(groupByDates:any):number[]{
    const chart_type = this.chartFilters.get('chartType').value

    let groupByDatesValues: number[] = [];
     Object.keys(groupByDates).forEach(chartDate => {
      let sumDateValues: number = 0
      Object.values(groupByDates[chartDate]).forEach((f: any) => {
        switch (chart_type) {
          case "FREE_DISK_SPACE_PERCENTAGE":
            sumDateValues = + this.validateNull(f.pcFreeDiskSpacePercentage)
            break;
          case "RAM_USAGE_PERCENTAGE":
            sumDateValues = + this.validateNull(f.pcRamUsagePercentage)
            break;
          case "VIDEO_RAM_USAGE_PERCENTAGE":
            sumDateValues = + this.validateNull(f.pcVideoRamUsagePercentage)
            break;
          case "CPU_AVG_USAGE_PERCENTAGE":
            sumDateValues = + this.validateNull(f.pcCpuAvgUsagePercentage)
            break;
          case "CONNECTION_LOST":
            if (f.pingResponse !== undefined) {
              let pingResponse = (f.pingResponse == null ? false : f.pingResponse)
              if (pingResponse == false) {
                sumDateValues++
              }
            }
            break;
        }
      })
      groupByDatesValues.push(sumDateValues)
    })

    return groupByDatesValues
  }

  getBarColorByValue(value: number): string {
  if (value < 30) return '#2ECC71';
  if (value < 60) return '#F1C40F	';
  if (value < 80) return '#E67E22	';
  return '#E74C3C	';
  }

  getLineColorByValue(value: number): string {
  if (value == 0) return '#2ECC71';
  return '#E74C3C	';
  }



  RenderConnectivityChart() {

    console.log("Render chart")
    let data = this.deviceAvailabilityData

    data.devicesStatusHistory = data.devicesStatusHistory.filter(f => f.scanDt >= this.minDate)

    let maxChartValue = undefined;

    this.DestroyChart("conectivityChart")

    const chart_type = this.chartFilters.get('chartType').value
    const query_type = this.chartFilters.get('queryType').value

    let chartType: 'bar' | 'line' = 'line';

    switch (chart_type) {
      case 'FREE_DISK_SPACE_PERCENTAGE':
        chartType = 'bar'
        // chartType = 'line'
        maxChartValue = 100;
        break;
      case 'RAM_USAGE_PERCENTAGE':
        chartType = 'bar'
        // chartType = 'line'
        maxChartValue = 100;
        break;
      case 'VIDEO_RAM_USAGE_PERCENTAGE':
        chartType = 'bar'
        // chartType = 'line'
        maxChartValue = 100;
        break;
      case 'CPU_AVG_USAGE_PERCENTAGE':
        chartType = 'bar'
        // chartType = 'line'
        maxChartValue = 100;
        break;
      case 'CONNECTION_LOST':
        // chartType = 'bar'
        chartType = 'line'
          maxChartValue = undefined;
        break;
      default:
        // chartType = 'bar'
        chartType = 'line'
        maxChartValue = undefined;
        break;
    }

    this.GroupInfoByHourDay(data, query_type, chart_type, this.lang)
    let groupByDates = _.groupBy(data.devicesStatusHistory, 'chartDate')
    let groupByDatesValues: number[] = this.fillGroupByDateValues(groupByDates)

    let datasets: any[] = []

    if (chartType == 'bar') {
      datasets.push({
        label: this.device.Name,
        data: groupByDatesValues,
        backgroundColor: groupByDatesValues.map(this.getBarColorByValue),
        
        borderWidth: 0,
        borderColor: 'transparent',
        
      })
    } else {
      datasets.push({
        label: this.device.Name,
        data: groupByDatesValues,
        backgroundColor: groupByDatesValues.map(this.getLineColorByValue),
        borderColor: 'gainsboro',//groupByDatesValues.map(this.getLineColorByValue),
        // backgroundColor: [
        //   "#003B75"
        // ],
        // borderColor: [
        //   "#003B75"
        // ],
        borderWidth: 1,
      })
    }
    
    Chart.defaults.font.size = 9

    const chart = new Chart("conectivityChart", {
      type: chartType,

      data: {
        labels: Object.keys(groupByDates),
        datasets: datasets,
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            align: 'start',
            labels: {
              borderRadius: 4,
              useBorderRadius: true,
              boxWidth: 7,
              boxHeight: 7,
              font: {
                size: 11
              }
            }
          },
          zoom: {
            pan: {
              enabled: true,
              mode: 'x'
            },
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x'
            }
          }
        },
        indexAxis: 'x',
        scales: {
          x: {
            ticks: {
              autoSkip: true
            }
          },
          y: {
            suggestedMin: 0,
            ticks: {
              precision: 0
            },
            min: 0,
            max: maxChartValue
          }
        }
      },
      plugins: [this.chartAreaBorder]
    });
  }

  public search() {
    this.getDevicesAvailability()
  }

  public openCardControlsMini : boolean = false

  openCardControlsMiniEvent(){
    this.openCardControlsMini = true
  }

  closeCardControlsMiniEvent(){
    this.openCardControlsMini = false;
  }

  private chartAreaBorder = {
    id: 'chartAreaBorder',
    beforeDraw(chart, args, options) {
      const {ctx, chartArea: {left, top, width, height}} = chart;
      ctx.save();
      
      ctx.strokeStyle = '#dfdfdf';
      ctx.lineWidth = 1;
      ctx.setLineDash(options.borderDash || []);
      ctx.lineDashOffset = options.borderDashOffset;
      ctx.strokeRect(left, top - 6, width, height + 12);
      ctx.restore();
    }
  };
}

